import React from "react";
import transition from "../transition";

const Contact = () => {
  return (
    <div className="container">
      <h1>Contact</h1>
    </div>
  );
};

export default transition(Contact);
